export enum FormStatus {
  AllUnshared = 'Sharing selected forms with "Complete" status will be available via RxPortal for read only. The client can fill&sign other forms via RxPortal.',
  SubmissionPending = 'Unsharing selected forms will change their form status to "Incomplete".',

  //when selecting an unshared form with status Incomplete, supervisor review, director review, client submitted
  UnsharedLowStatus = 'Sharing selected forms will change their form status to "Submission Pending".', // The client can fill & sign these forms via RxPortal.

  SharedComplete = 'Completing this action makes this form unavailable to the client in RxPortal.',
  UnsharedComplete = 'Completing this action makes forms available to the client in RxPortal for readonly.',
  CompleteSubmissionPending = 'Completing this action makes this form unavailable to the client in RxPortal. Please note: "Submission Pending" forms will change to "Incomplete".',
}
